import { isValidationReady, validateText } from './textValidation';

export const VALIDATION_RULES = {
  name: {
    required: true,
    minLength: 2,
    maxLength: 20,
    pattern: /^[a-zA-Z\s-']+$/,
    message: {
      required: 'Name is required',
      minLength: 'Name must be at least 2 characters',
      maxLength: 'Name cannot exceed 20 characters',
      pattern: 'Name can only contain letters, spaces, hyphens and apostrophes'
    }
  },
  dob: {
    required: true,
    validate: (value) => {
      const date = new Date(value);
      const today = new Date();
      
      // Check if it's a valid date
      if (isNaN(date.getTime())) {
        return false;
      }
      
      // Check if date is in the future
      if (date > today) {
        return false;
      }
      
      // Optional: Check if date is too far in the past (e.g., more than 150 years)
      const maxAge = new Date();
      maxAge.setFullYear(maxAge.getFullYear() - 150);
      if (date < maxAge) {
        return false;
      }
      
      return true;
    },
    message: {
      required: 'Date is required',
      validate: 'Please enter a valid date (cannot be in the future or more than 150 years ago)'
    }
  },
  pob: {
    required: true,
    minLength: 2,
    maxLength: 100,
    message: {
      required: 'Place is required',
      minLength: 'Place must be at least 2 characters',
      maxLength: 'Place cannot exceed 100 characters'
    }
  },
  message: {
    required: false,
    minLength: 10,
    maxLength: 500,
    message: {
      required: 'Message is required',
      minLength: 'Message must be at least 10 characters',
      maxLength: 'Message cannot exceed 500 characters'
    }
  }
};

export const validateField = (name, value) => {
  const rules = VALIDATION_RULES[name];
  if (!rules) return { isValid: true };

  // Check if content validation is ready
  if (!isValidationReady()) {
    return { 
      isValid: false, 
      error: 'Validation system is not ready' 
    };
  }

  // First check for blocked words in text fields
  if (['name', 'pob', 'message'].includes(name) && value?.trim()) {
    const contentValidation = validateText(value);
    if (!contentValidation.isValid) {
      return {
        isValid: false,
        error: contentValidation.error
      };
    }
  }

  // Required check
  if (rules.required && !value?.trim()) {
    return {
      isValid: false,
      error: rules.message.required
    };
  }

  const errors = [];

  // Length checks
  if (rules.minLength && value.trim().length < rules.minLength) {
    errors.push(rules.message.minLength);
  }
  if (rules.maxLength && value.trim().length > rules.maxLength) {
    errors.push(rules.message.maxLength);
  }

  // Pattern check
  if (rules.pattern && !rules.pattern.test(value)) {
    errors.push(rules.message.pattern);
  }

  // Custom validation
  if (rules.validate && !rules.validate(value)) {
    errors.push(rules.message.validate);
  }

  return {
    isValid: errors.length === 0,
    error: errors.length > 0 ? errors[0] : null
  };
}; 